<template>
  <form class="color-picker" v-on:submit.prevent="onSubmit">
    <v-color-picker
      hide-inputs
      hide-mode-switch
      v-bind:value="color"
      v-on:input="onInput"
      width="270"
    />
    <color-select
      class="color-picker__presets"
      v-bind:colors="presets"
      v-bind:color="color"
      v-on:change-color="onInput"
    />
    <div class="color-picker__buttons">
      <button class="color-picker__button-cancel" type="button" v-on:click="onCancel">
        Отмена
      </button>
      <button class="color-picker__button-submit" type="submit">Сохранить</button>
    </div>
  </form>
</template>

<script>
import ColorSelect from '@/components/ColorSelect.vue';
import { builtInPopoverMixin } from '@/mixins/builtInPopoverMixin';

export default {
  components: { ColorSelect },
  computed: {
    isShowSwatches() {
      return this.presets.length > 0;
    },
  },
  data() {
    return {
      color: this.initialColor,
    };
  },
  methods: {
    onCancel() {
      this.closePopover();
    },
    onInput(value) {
      this.color = value;
    },
    onSubmit() {
      if (this.initialColor !== this.color) {
        this.$emit('change', this.color);
      }
      this.closePopover();
    },
  },
  mixins: [builtInPopoverMixin],
  name: 'ColorPicker',
  props: {
    initialColor: { required: true, type: String },
    presets: { default: () => [], type: Array },
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";
.color-picker {
  &__presets {
    padding: 0 16px 16px;
    max-width: 270px;
  }
  &__buttons {
    display: flex;
    gap: 10px;
    padding: 16px;
  }
  &__button {
    &-cancel {
      @include buttons.btn-transparent(100%, 2rem, 1rem);
    }
    &-submit {
      @include buttons.btn-blue(100%, 2rem, 1rem);
    }
  }
}
</style>
